import { LineChart } from '../../charts/LineChart';
import { ChartModelHelper } from '../../helpers/ChartModelHelper';
import type { IComponentFacts } from '../../types/report';
import { EmptyFacts } from '../EmptyFacts';
import { percentFormatter } from './chartFormatters';
import { useChartStyle } from './useChartStyle';
import { useTrendMonths } from './useTrendMonths';

interface IMarginTrendChartProps {
  facts: IComponentFacts;
}

const LABELS = {
  grossMargin: 'Gross margin',
  ebitdaMargin: 'EBITDA margin',
  netMargin: 'Net margin',
};

export const MarginTrendChart = ({ facts }: IMarginTrendChartProps) => {
  const months = useTrendMonths(facts, { allowPreliminary: true });
  const style = useChartStyle(3);
  const rows = ChartModelHelper.marginTrend(facts.table, months);
  if (!ChartModelHelper.hasSeries(rows, 'grossMargin')) return <EmptyFacts />;
  return (
    <LineChart
      {...style}
      className="h-full"
      data={ChartModelHelper.relabel(rows, LABELS)}
      index="label"
      categories={Object.values(LABELS)}
      colors={['blue', 'emerald', 'violet']}
      valueFormatter={percentFormatter}
      yAxisWidth={64}
      connectNulls
      autoMinValue
    />
  );
};
